var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('ul',_vm._l((_vm.extras.subpages),function(value,key){return _c('li',{key:key,class:_vm.extras.cardClasses},[_c('a',{attrs:{"href":value.href,"target":value.target}},[_vm._v(_vm._s(key))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }